import { loadNavigationEpic } from "~/features/navigation/redux/loadNavigationEpic";
import { type NavigationNode } from "~/domains/navigation/types/NavigationTypes";
import { getStore } from "~/app/store/getStore";

export function create(rawData: { navigation: string; flyoutNavigation: string }) {
  getStore().dispatch(loadNavigationEpic(rawData));

  return null;
}

export type NavigationData = {
  root: NavigationNode;
  nodes: Dictionary<NavigationNode>;
};
